import { CHART_CONFIG, CHART_TYPES } from "../chartConfig";

/**
 * Get table configuration from CHART_CONFIG
 * @param {string} chartType - Chart type constant
 * @param {number} level - Table level (1 or 2)
 * @param {Object} selectedDataPoint - Selected data point (optional, for dynamic configs)
 * @param {string} baseEntityTypePluralLable - Base entity plural label (optional, defaults to "vehicles")
 * @returns {Object|null} Table configuration or null
 */
export const getTableConfigFromChartConfig = (chartType, level = 1, selectedDataPoint = null, baseEntityTypePluralLable = "vehicles") => {
  const chartConfig = CHART_CONFIG[chartType];
  if (!chartConfig?.popupConfig) {
    return null;
  }

  if (level === 1) {
    const summaryTable = chartConfig.popupConfig.summaryTable;
    if (!summaryTable) return null;

    return {
      title: typeof summaryTable.title === 'function'
        ? summaryTable.title(selectedDataPoint)
        : summaryTable.title,
      tableColumnsConfig: summaryTable.tableColumnsConfig,
      tableColumnOrder: summaryTable.tableColumnOrder,
      emptyMessage: "No alerts found for the selected criteria",
    };
  }

  if (level === 2) {
    const vehiclesTable = chartConfig.popupConfig.vehiclesTable;
    if (!vehiclesTable) return null;

    return {
      title: typeof vehiclesTable.title === 'function'
        ? vehiclesTable.title(selectedDataPoint)
        : vehiclesTable.title,
      tableColumnsConfig: vehiclesTable.tableColumnsConfig,
      tableColumnOrder: vehiclesTable.tableColumnOrder,
      emptyMessage: `No ${baseEntityTypePluralLable.toLowerCase()} found for the selected fault`,
    };
  }

  return null;
};

/**
 * Build default modal title from chart title and selected data point
 * @param {string} chartTitle - Chart title
 * @param {Object} selectedDataPoint - Selected data point
 * @param {Function} buildDateCategory - Function to build date category
 * @returns {JSX.Element} Modal title component
 */
export const buildDefaultModalTitle = (chartTitle, selectedDataPoint, buildDateCategory) => {
  const { Grid2, Typography } = require("@mui/material");
  const metricName = selectedDataPoint?.metricName || "Faults";
  const category = buildDateCategory(selectedDataPoint);

  return (
    <Grid2 container gap={1} alignItems={"center"}>
      <Typography variant="fw500s16c8F8F8F" sx={{ lineHeight: "28px" }}>
        {chartTitle}
        <Typography variant="fw500s16c000000" sx={{ lineHeight: "28px" }}>
          {' / '}{metricName}
        </Typography>
      </Typography>
      <Typography variant="fw500s14c686868" sx={{ lineHeight: "20px" }}>
        {'•'}
      </Typography>
      <Typography variant="fw500s14c686868" sx={{ lineHeight: "20px" }}>
        {category}
      </Typography>
    </Grid2>
  );
};

/**
 * Build default level 2 title
 * @param {Object} level2Record - Level 2 record
 * @returns {JSX.Element} Level 2 title component
 */
export const buildDefaultLevel2Title = (level2Record) => {
  const { Grid2, Typography } = require("@mui/material");
  const rowTitle = level2Record?.xLabel || level2Record?.faultName || "Fault";
  const category = "Details";

  return (
    <Grid2 container gap={1} alignItems={"center"}>
      <Typography variant="fw400s14c8F8F8F" sx={{ lineHeight: "28px" }}>
        {rowTitle}
        <Typography variant="fw400s14c000000" sx={{ lineHeight: "28px" }}>
          {' / '}{category}
        </Typography>
      </Typography>
    </Grid2>
  );
};
